<template>
  <div>
    <el-container direction="vertical">
      <el-row style="margin-bottom: 0px; margin-top: 10px">
        <el-card
          v-if="infoVisible"
          shadow="never"
          style="margin-left: 0px"
          :body-style="{ padding: '10px' }"
        >
          <div>
            <el-col :span="6">
              <el-card
                :body-style="{ backgroundColor: '#fff' }"
                style="
                  background-color: #9fccfc;
                  margin-top: 0px;
                  margin-left: 0px;
                  margin-right: 0px;
                  margin-bottom: 10px;
                  width: 100%;
                  height: 320px;
                "
              >
                <div slot="header">
                  <span
                    style="font-weight: bolder; font-size: 16px; color: #303133"
                    >{{ baseFormData.name }}</span
                  >
                  <span :class="baseFormData.label0">糖</span>
                  <span :class="baseFormData.label1">压</span>
                  <span :class="baseFormData.label2">尿</span>
                  <span :class="baseFormData.label3">脂</span>
                  <span :class="baseFormData.label4">重</span>
                  <span :class="baseFormData.label5">肺</span>
                  <!-- <el-tag v-if="isBloodpressure" style="float: right;" size="small" type="danger">压</el-tag>
                  <el-tag v-if="isDiabet" style="float: right;margin-right: 10px;" size="small" type="danger">糖</el-tag> -->
                </div>

                <el-descriptions :column="1" :colon="false">
                  <!-- <template slot="extra">
                    <el-tag size="small" type="danger">压</el-tag>
                    <el-tag size="small" type="danger" style="margin-left: 10px;">糖</el-tag>
                  </template> -->
                  <el-descriptions-item label="性别年龄:">{{
                    getGender(baseFormData.gender) +
                    " " +
                    getAge(baseFormData.birthday)
                  }}</el-descriptions-item>
                  <el-descriptions-item label="出生日期:">{{
                    baseFormData.birthday
                  }}</el-descriptions-item>
                  <el-descriptions-item label="身份证号:">{{
                    baseFormData.idcard
                  }}</el-descriptions-item>
                  <el-descriptions-item label="联系方式:">{{
                    baseFormData.phone
                  }}</el-descriptions-item>
                  <!-- <el-descriptions-item label="慢病信息:">糖尿病不达标,高血压低危</el-descriptions-item> -->
                  <el-descriptions-item label="状态:">
                    <el-tag size="small" type="success">{{
                      baseFormData.integrateManageStatus
                    }}</el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="管理科室:">{{
                    baseFormData.integrateManageDeptName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="责任医师:">{{
                    baseFormData.doctorResponse
                  }}</el-descriptions-item>
                </el-descriptions>
              </el-card>

              <el-card
                style="
                  margin-top: 0px;
                  margin-left: 0px;
                  margin-right: 0px;
                  margin-bottom: 10px;
                  width: 100%;
                  height: 400px;
                "
              >
                <div slot="header">
                  <span
                    style="font-weight: bolder; font-size: 16px; color: #303133"
                    >近期检测</span
                  >

                  <el-radio-group
                    v-model="monitorType"
                    size="mini"
                    style="float: right"
                    @change="monitorTypeChange"
                  >
                    <el-radio-button label="血糖"></el-radio-button>
                    <el-radio-button label="血压"></el-radio-button>
                  </el-radio-group>
                </div>

                <el-row>
                  <el-table
                    border
                    ref="monitorTable"
                    size="mini"
                    :data="manageDataList"
                    height="300px"
                    fit
                    style="width: 100%; margin-top: 0px"
                    :show-header="false"
                  >
                    <el-table-column
                      align="center"
                      style="background-color: #9fccfc"
                    >
                      <template slot-scope="scope">
                        <el-descriptions
                          size="mini"
                          class="margin-top"
                          :column="1"
                          direction="vertical"
                        >
                          <el-descriptions-item
                            :label="getMonitorTitle(scope.row)"
                            >{{
                              getMonitorContent(scope.row)
                            }}</el-descriptions-item
                          >
                        </el-descriptions>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="90px"
                      align="center"
                      label="检测时间"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.time }}</span>
                      </template>
                    </el-table-column>

                    <!-- <el-table-column width="80px" align="center" label="服务频次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.fre }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="100px" align="center" label="上次执行时间">
                      <template slot-scope="scope">
                        <span>{{ scope.row.time }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="80px" align="center" label="检查结果">
                      <template slot-scope="scope">
                        <span>{{ scope.row.result }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="100px" align="center" label="下次到期时间">
                      <template slot-scope="scope">
                        <span>{{ scope.row.expireTime }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="60px" align="center" label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.status }}</span>
                      </template>
                    </el-table-column> -->

                    <!-- <el-table-column align="center" fixed="right" label="操作" width="60">
                      <template>

                        <el-button style="margin-left: 5px; align-self: center" type="text">
                          查看
                        </el-button>
                      </template>
                    </el-table-column> -->
                  </el-table>
                </el-row>
              </el-card>
            </el-col>

            <el-col :span="9">
              <el-card
                :body-style="{ backgroundColor: '#fff' }"
                style="
                  background-color: #a4aefc;
                  margin-top: 0px;
                  margin-left: 10px;
                  margin-right: 0px;
                  margin-bottom: 10px;
                  width: 100%;
                "
              >
                <div slot="header">
                  <span
                    style="font-weight: bolder; font-size: 16px; color: white"
                    >慢病专项信息</span
                  >
                </div>

                <el-row>
                  <el-descriptions
                    style="height: 170px"
                    size="mini"
                    title="近期体征情况"
                    direction="vertical"
                    :column="5"
                    border
                  >
                    <el-descriptions-item label="身高(cm)">{{
                      patientBaseInfoData.height
                    }}</el-descriptions-item>
                    <el-descriptions-item label="体重(kg)">{{
                      patientBaseInfoData.weight
                    }}</el-descriptions-item>
                    <el-descriptions-item label="BMI(kg/㎡)">{{
                      patientBaseInfoData.bmi
                    }}</el-descriptions-item>
                    <el-descriptions-item label="收缩压">{{
                      patientBaseInfoData.sbp
                    }}</el-descriptions-item>
                    <el-descriptions-item label="舒张压">{{
                      patientBaseInfoData.dbp
                    }}</el-descriptions-item>
                    <el-descriptions-item label="腰围(cm)">{{
                      patientBaseInfoData.waist
                    }}</el-descriptions-item>
                    <el-descriptions-item label="血糖">{{
                      patientBaseInfoData.bloodSugar
                    }}</el-descriptions-item>
                    <el-descriptions-item label="血糖类型">{{
                      patientBaseInfoData.bloodSugarType
                    }}</el-descriptions-item>
                    <el-descriptions-item label="尿酸">{{
                      patientBaseInfoData.ua
                    }}</el-descriptions-item>
                    <el-descriptions-item label="总胆固醇">{{
                      patientBaseInfoData.tc
                    }}</el-descriptions-item>
                  </el-descriptions>
                </el-row>

                <el-row style="margin-top: 20px">
                  <span
                    style="font-weight: bolder; font-size: 16px; color: #303133"
                    >近期检验检查</span
                  >

                  <el-radio-group
                    v-model="labAndExamType"
                    size="mini"
                    style="float: right"
                    @change="labAndExamTypeChange"
                  >
                    <el-radio-button label="检验"></el-radio-button>
                    <el-radio-button label="检查"></el-radio-button>
                  </el-radio-group>
                </el-row>

                <el-row>
                  <el-table
                    border
                    size="mini"
                    :data="labAndExamData"
                    height="200px"
                    fit
                    highlight-current-row
                    style="width: 100%; margin-top: 10px"
                    :show-header="false"
                  >
                    <el-table-column align="left" label="项目名称">
                      <template slot-scope="scope">
                        <span>{{ getTestItemName(scope.row) }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="120px"
                      align="center"
                      label="报告时间"
                    >
                      <template slot-scope="scope">
                        <span>{{ getParsedTime(scope.row.reportTime) }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="60px" align="center" label="操作">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="getItemDetail(scope.row)"
                          style="margin-left: 5px; align-self: center"
                          type="text"
                        >
                          查看
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>

                <lab-detail
                  v-if="labReportDetailVisible"
                  ref="LabReportDetailRef"
                ></lab-detail>

                <exam-detail
                  v-if="examReportDetailVisible"
                  ref="ExamReportDetailRef"
                ></exam-detail>

                <el-row style="margin-top: 20px">
                  <span
                    style="font-weight: bolder; font-size: 16px; color: #303133"
                    >当前用药</span
                  >
                </el-row>

                <el-row>
                  <el-table
                    border
                    size="mini"
                    :data="drugList"
                    height="150px"
                    fit
                    highlight-current-row
                    style="width: 100%; margin-top: 10px"
                    :show-header="false"
                  >
                    <el-table-column align="left" label="项目名称">
                      <template slot-scope="scope">
                        <span>{{ scope.row.drugName }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-card>
            </el-col>

            <el-col :span="8">
              <!-- <el-card style="
                margin-top: 0px;
                margin-left: 0px;
                margin-right: 5px;
                margin-bottom: 10px;
                width: 320px;
                height: 180px;
              ">
                <el-descriptions title="一体化管理" :column="1" :colon="false">
                  <template slot="extra">
                    <el-button type="primary" size="mini">查看服务记录</el-button>
                    <el-button type="primary" size="mini">重新生成一体化方案</el-button>
                  </template>
                  <el-descriptions-item label="当前一体化方案:">糖尿病不达标+高血压低压管理</el-descriptions-item>
                  <el-descriptions-item label="评估人:">单宝华</el-descriptions-item>
                  <el-descriptions-item label="生成时间:">2025-05-01</el-descriptions-item>
                </el-descriptions>
              </el-card> -->

              <el-card
                :body-style="{ backgroundColor: '#fff' }"
                style="
                  background-color: #6089ff;
                  margin-top: 0px;
                  margin-left: 20px;
                  margin-right: 10px;
                  margin-bottom: 10px;
                  width: 100%;
                "
              >
                <div slot="header">
                  <span
                    style="font-weight: bolder; font-size: 16px; color: white"
                    >一体化管理信息</span
                  >
                </div>
                <el-row>
                  <el-radio-group
                    v-model="integratedType"
                    size="mini"
                    style="float: left"
                    @change="integratedTypeChange"
                  >
                    <el-radio-button label="待开始"></el-radio-button>
                    <el-radio-button label="进行中"></el-radio-button>
                    <el-radio-button label="已逾期"></el-radio-button>
                    <el-radio-button label="已完成"></el-radio-button>
                  </el-radio-group>
                </el-row>
                <el-row>
                  <el-table
                    size="mini"
                    v-loading="listLoading"
                    :data="list"
                    height="583px"
                    border
                    fit
                    highlight-current-row
                    style="width: 100%; margin-top: 20px"
                  >
                    <el-table-column
                      width="80px"
                      align="center"
                      label="项目名称"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="100px"
                      align="center"
                      label="下次到期时间"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.expireTime }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="80px"
                      align="center"
                      label="服务频次"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.fre }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="100px"
                      align="center"
                      label="上次执行时间"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.time }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="80px"
                      align="center"
                      label="检查结果"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.result }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      width="100px"
                      align="center"
                      label="下次到期时间"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.expireTime }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="60px" align="center" label="状态">
                      <template slot-scope="scope">
                        <span>{{ scope.row.status }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column
                      align="center"
                      fixed="right"
                      label="操作"
                      width="60"
                    >
                      <template>
                        <!-- <el-button style="margin-left: 0px; align-self: center" type="text">
                          修改
                        </el-button>

                        <el-button style="margin-left: 5px; align-self: center" type="text">
                          执行
                        </el-button> -->

                        <el-button
                          style="margin-left: 5px; align-self: center"
                          type="text"
                        >
                          查看
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>

                  <pagination
                    v-show="total > 0"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList"
                  />
                </el-row>
              </el-card>
            </el-col>
          </div>
        </el-card>
      </el-row>
      <el-empty
        v-if="emptyVisible"
        description="该患者暂无健康档案信息"
      ></el-empty>
    </el-container>
  </div>
</template>

<script>
import {
  getAppDiabetSpecData,
  getSearchList,
  getSysDicList,
  getPatientHealthSummary,
  getBloodSugarList,
  getBloodPressureList,
} from "@/api/health/Patients";
import { getExamReportInfos } from "@/api/health/ExamReportQuery";
import { getLabInfos } from "@/api/health/LabQuery";
import { getLatestRiskFactors } from "@/api/health/RiskQuery";
import { getPatientDrugUsage } from "@/api/health/VisitQuery";
import moment from "moment";

import imageLine from "@/assets/images/titleLine.png";
import { time } from "echarts";
import Pagination from "@/components/Pagination";
import examDetail from "../diseaseInfo/labAndExam/examDetail.vue";
import labDetail from "../diseaseInfo/labAndExam/labDetail.vue";

export default {
  components: { Pagination, examDetail, labDetail },
  props: {
    pInfo: null,
  },
  data() {
    return {
      dialogDeptTableVisible: false,
      allDeptDataList: null,
      allDeptDataListLoading: false,
      examReportDetailVisible: false,
      labReportDetailVisible: false,
      total: 0,
      list: null,
      listLoading: false,
      listQuery: {
        name: null,
        pageNum: 1,
        pageSize: 10,
      },
      baseFormData: {
        name: null,
        idcard: null,
        phone: null,
        doctorResponse: null,
        integrateManageStatus: null,
        integrateManageDeptName: null,
      },
      infoVisible: true,
      emptyVisible: false,
      height: null,
      weight: null,
      waist: null,
      BMI: null,
      medicalQualitySortVisible: false,
      medicalEffciencySortVisible: false,
      operativeIndexVisible: false,
      profitDiseaseSortVisible: false,
      hospitalizationIncomeVisible: false,
      outpatientIncomeVisible: false,
      medicalServiceDetailVisible: false,
      linkLine: imageLine,
      detail: null,
      deptTopType: "年",
      drgTopType: "智能排序",
      period: "年",
      periodMonth: null,
      periodYear: null,
      periodQuarter: null,
      periodOptions: [
        { value: "月", label: "月" },
        { value: "季", label: "季" },
        { value: "年", label: "年" },
      ],
      periodQuarterOptions: [
        { value: "1", label: "第一季度" },
        { value: "2", label: "第二季度" },
        { value: "3", label: "第三季度" },
        { value: "4", label: "第四季度" },
      ],
      sexOptions: [],
      integratedType: "进行中",
      monitorType: "血糖",
      patientBaseInfoData: {
        idcard: null,
        birthday: null,
        gender: null,
        height: null,
        weight: null,
        bmi: null,
        sbp: null,
        dbp: null,
        bloodSugar: null,
        bloodSugarType: null,
        ua: null,
        tc: null,
        tg: null,
        hdlc: null,
        ldlc: null,
        waist: null,
        createTime: null,
        updateTime: null,
        lastTime: null,
        visitTime: null,
      },
      manageDataList: [],
      managebgList: [],
      managebpList: [],
      labAndExamType: "检验",
      labAndExamData: [],
      examDataList: [],
      labDataList: [],
      drugList: [],
      isBloodpressure: false,
      isDiabet: false,
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);

    console.log("患者健康档案信息：", this.pInfo);

    if (this.pInfo.isBloodpressure == "是") {
      this.isBloodpressure = true;
    }

    if (this.pInfo.isDiabet == "是") {
      this.isDiabet = true;
    }

    this.getPatientHealthInfoParams();

    this.getPatientInfo();
    this.getList();
    this.getPatientHealthSummaryInfo();

    this.getBloodSugarList();
    this.getBloodPressureList();

    this.getLabList();
    this.getExamList();

    this.getDrugList();
  },
  methods: {
    getPatientHealthSummaryInfo() {
      var query = {
        idcard: this.pInfo.idcard,
      };
      getPatientHealthSummary(query).then((res) => {
        if (res.msg == "success") {
          this.patientBaseInfoData = res.data;
        }
      });
    },
    getPatientInfo() {
      var query = {
        idcard: this.pInfo.idcard,
      };
      getSearchList(query).then((res) => {
        if (res.msg == "success") {
          if (res.data.records.length > 0) {
            this.baseFormData = res.data.records[0];
            this.baseFormData.label0 = this.setLabel0(this.baseFormData)
              ? this.setLabel0(this.baseFormData)
              : "labelNone";
            this.baseFormData.label1 = this.setLabel1(this.baseFormData)
              ? this.setLabel1(this.baseFormData)
              : "labelNone";
            this.baseFormData.label2 = this.setLabel2(this.baseFormData)
              ? this.setLabel2(this.baseFormData)
              : "labelNone";
            this.baseFormData.label3 = this.setLabel3(this.baseFormData)
              ? this.setLabel3(this.baseFormData)
              : "labelNone";
            this.baseFormData.label4 = this.setLabel4(this.baseFormData)
              ? this.setLabel4(this.baseFormData)
              : "labelNone";
            this.baseFormData.label5 = this.setLabel5(this.baseFormData)
              ? this.setLabel5(this.baseFormData)
              : "labelNone";
          } else {
            this.infoVisible = false;
            this.emptyVisible = true;
          }
        }
      });
    },
    //查询用药
    getDrugList() {
      var params = {
        idcard: this.pInfo.idcard,
        startTime: null,
        endTime: null,
        pageNum: 0,
        pageSize: 10,
      };

      getPatientDrugUsage(params).then((response) => {
        this.drugList = response.contents;
      });
    },
    //查询血糖
    getBloodSugarList() {
      var params = {
        measurerName: this.pInfo.name,
        idcard: this.pInfo.idcard,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      };

      getBloodSugarList(params).then((res) => {
        if (res.msg == "success") {
          this.managebgList = res.data.records;
          this.manageDataList = this.managebgList;
        }
      });
    },
    //查询血压
    getBloodPressureList() {
      var params = {
        measurerName: this.pInfo.name,
        idcard: this.pInfo.idcard,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      };

      getBloodPressureList(params).then((res) => {
        if (res.msg == "success") {
          this.managebpList = res.data.records;
        }
      });
    },
    getMonitorTitle(row) {
      console.log(this.monitorType, row);
      if (this.monitorType == "血糖") {
        return row.measureStatus;
      } else {
        return "收缩压/舒张压";
      }
    },
    getMonitorContent(row) {
      console.log(this.monitorType, row);
      if (this.monitorType == "血糖") {
        return row.bloodSugar;
      } else {
        return row.systolicPressure + "/" + row.diastolicPressure;
      }
    },
    getGenderAndAge() {},
    integratedTypeChange(type) {
      console.log("一体化类型筛选：", type);
    },
    monitorTypeChange(type) {
      console.log("血压血糖类型筛选：", type);
      if (type == "血糖") {
        // this.getBloodSugarList();
        // this.monitorTable.data = this.managebgList;
        this.manageDataList = this.managebgList;
      } else {
        // this.getBloodPressureList();
        // this.monitorTable.data = this.managebpList;
        this.manageDataList = this.managebpList;
      }
    },
    labAndExamTypeChange(type) {
      console.log("检验检查类型筛选：", type);
      if (type == "检验") {
        this.labAndExamType = "检验";
        this.labAndExamData = this.labDataList;
      } else {
        this.labAndExamType = "检查";
        this.labAndExamData = this.examDataList;
      }
    },
    getItemDetail(row) {
      if (this.labAndExamType == "检验") {
        this.labReportDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.LabReportDetailRef.init(row);
        });
      } else {
        this.examReportDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.ExamReportDetailRef.init(row);
        });
      }
    },
    getTestItemName(row) {
      var testItemStr = "";
      if (this.labAndExamType == "检验") {
        if (row.testItems != null && row.testItems.length > 0) {
          // for (let i = 0; i < row.testItems.length; i++) {
          //   const item = row.testItems[i];
          //   if (testItemStr == "") {
          //     testItemStr = item.itemName;
          //   } else {
          //     testItemStr = testItemStr + "," + item.itemName;
          //   }
          // }
          testItemStr = row.name
        }
      } else {
        // if (row.examItems != null && row.examItems.length > 0) {
        //   for (let i = 0; i < row.examItems.length; i++) {
        //     const item = row.examItems[i];
        //     if (testItemStr == "") {
        //       testItemStr = item.itemName;
        //     } else {
        //       testItemStr = testItemStr + "," + item.itemName;
        //     }
        //   }
        // }
        testItemStr = row.reportName
      }

      return testItemStr;
    },
    getLabList() {
      var params = {
        idcard: this.pInfo.idcard,
        queryDetail: 1,
      };

      console.log("检验data:", params);

      getLabInfos(params).then((response) => {
        this.labDataList = response.contents;
        this.labAndExamData = response.contents;
      });
    },
    getExamList() {
      var params = {
        idcard: this.pInfo.idcard,
        queryDetail: 1,
      };

      console.log("检查data:", params);

      getExamReportInfos(params).then((response) => {
        this.examDataList = response.contents;
      });
    },
    getPatientHealthInfoParams() {
      if (this.pInfo == null) {
        this.infoVisible = false;
        this.emptyVisible = true;
        return;
      }

      const params = {
        startTime: null,
        endTime: null,
        idcard: this.pInfo.idcard,
        paramNames: ["身高", "体重", "腰围", "BMI"],
      };

      getLatestRiskFactors(params)
        .then((res) => {
          console.log("=======chushihua shuju========", res);
          if (res.msg == "success") {
            var records = res.data.records;
            if (records.length > 0) {
              var res = records[0];
              if (res.healthParams.length > 0) {
                for (let i = 0; i < res.healthParams.length; i++) {
                  const item = res.healthParams[i];
                  if (item.paramName == "体重") {
                    this.weight = item.paramValue;
                  }
                  if (item.paramName == "身高") {
                    this.height = item.paramValue;
                  }
                }
              }
              if (this.weight != null && this.height != null) {
                var w = parseFloat(this.weight);
                var h = parseFloat(this.height) / 100;
                this.BMI = Number(w / h / h).toFixed(2);
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickIncomePie(event) {
      console.log("点击p");
      console.log(event);
    },
    clearEvent() {
      this.listQuery.name = null;
      // this.getList();
    },
    getList() {
      this.list = [
        {
          name: "血压",
          fre: "每月一次",
          time: "2025-05-01",
          result: "达标",
          expireTime: "2025-06-01",
          status: "待执行",
        },
        {
          name: "血压",
          fre: "每月一次",
          time: "2025-05-01",
          result: "达标",
          expireTime: "2025-06-01",
          status: "待执行",
        },
        {
          name: "血压",
          fre: "每月一次",
          time: "2025-05-01",
          result: "达标",
          expireTime: "2025-06-01",
          status: "待执行",
        },
      ];
    },
    exportList() {},
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    getSystemDictList(typeName) {
      var typeData = {
        typeName: typeName,
      };
      getSysDicList(typeData)
        .then((res) => {
          var records = [];
          if (res.msg == "success") {
            var data = res.data;
            records = data.records;
          }
          this.sexOptions = records;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGender(gender) {
      console.log("getgender:", gender, this.sexOptions);
      var option = this.sexOptions.filter((v) => v.value == gender)[0];
      return option.name;
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
        (d.getMonth() == birthdays.getMonth() &&
          d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    setLabel0(item) {
      //糖尿病
      var labels = item.labels;
      if (labels != null && labels.length > 0) {
        const isIncluded = labels.some((dt) => dt.label === "diabet");
        const isIncluded2 = labels.some((dt) => dt.label === "diabet_danger");
        const isIncluded3 = labels.some((dt) => dt.label === "easy_diabet");

        if (isIncluded) {
          return "labelRed";
        }

        if (isIncluded2) {
          return "labelRedCircle";
        }
      } else {
        return "labelNone";
      }
    },
    setLabel1(item) {
      //高血压
      var labels = item.labels;
      if (labels != null && labels.length > 0) {
        const isIncluded = labels.some(
          (dt) => dt.label === "hyper"
        );
        const isIncluded2 = labels.some((dt) => dt.label === "hyper_danger");
        const isIncluded3 = labels.some((dt) => dt.label === "easy_hyper");

        if (isIncluded) {
          return "labelRed";
        }

        if (isIncluded2) {
          return "labelRedCircle";
        }
      } else {
        return "labelNone";
      }
    },
    setLabel2(item) {
      //高尿酸
      var labels = item.labels;
      if (labels != null && labels.length > 0) {
        const isIncluded = labels.some((dt) => dt.label === "hyperuricemia");
        const isIncluded2 = labels.some(
          (dt) => dt.label === "hyperuricemia_danger"
        );
        const isIncluded3 = labels.some(
          (dt) => dt.label === "easy_hyperuricemia"
        );

        if (isIncluded) {
          return "labelRed";
        }

        if (isIncluded2) {
          return "labelRedCircle";
        }
      } else {
        return "labelNone";
      }
    },
    setLabel3(item) {
      //高血脂
      var labels = item.labels;
      if (labels != null && labels.length > 0) {
        const isIncluded = labels.some((dt) => dt.label === "bloodfat");
        const isIncluded2 = labels.some((dt) => dt.label === "bloodfat_danger");

        if (isIncluded) {
          return "labelRed";
        }

        if (isIncluded2) {
          return "labelRedCircle";
        }
      } else {
        return "labelNone";
      }
    },
    setLabel4(item) {
      //高体重
      var labels = item.labels;
      if (labels != null && labels.length > 0) {
        const isIncluded = labels.some((dt) => dt.label === "overweight");

        if (isIncluded) {
          return "labelRed";
        }
      } else {
        return "labelNone";
      }
    },
    setLabel5(item) {
      //慢阻肺 肺癌管理
      var labels = item.labels;
      if (labels != null && labels.length > 0) {
        const isIncluded = labels.some((dt) => dt.label === "lungcancer");
        const isIncluded2 = labels.some(
          (dt) => dt.label === "lungcancer_danger"
        );
        const isIncluded3 = labels.some((dt) => dt.label === "easy_lungcancer");

        if (isIncluded) {
          return "labelRed";
        }

        if (isIncluded2) {
          return "labelRedCircle";
        }
      } else {
        return "labelNone";
      }
    },
  },
};
</script>

<style>
.el-card ::v-deep .el-card__header {
  background-color: lightblue;
}

.box-card {
  width: 1443px;
}

.card-panel-col {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}

.card-panel-icon-wrapper {
  display: flex;
  width: 60px;
  height: 60px;
  flex-direction: column;
  justify-content: center;
  /* 水平居中*/
  align-items: center;
  margin-bottom: 10px;
}

.image {
  width: 50px;
  height: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
}

.cardImage1 {
  width: 80px;
  height: 80px;
}

.cardImage2 {
  width: 65px;
  height: 65px;
}

.card-panel-icon-wrapper2 {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  /* 水平居中*/
  align-items: center;
  margin-bottom: 10px;
}

.image2 {
  width: 50px;
  height: 50px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  /* 水平居中*/
  align-items: center;
}

.cardColor1 {
  background: linear-gradient(to right, #9fccfc, #618bff);
}

.cardColor2 {
  background: linear-gradient(to right, #a4aefc, #6089ff);
}

.el-progress-bar__inner {
  background-color: unset;
  background-image: linear-gradient(to right, #6855ff, #5aa2eb);
}

.labelRed {
    height: 24px;
	  width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
    text-align: center;
}

.labelRedCircle {
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid red;
    background: #fff;
    color: red;
    display: inline-block;
    text-align: center;
}

.labelBlue {
    border-radius: 50%;
    color: white;
    background: blue;
    padding: 3px;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelPurple {
    border: 1px solid purple;
    background: purple;
    color: #fff;
    padding: 2px;
    border-radius: 50%;
}

.labelNone {
    display: none;
}
</style>
